<template>
  <section class="input-delta-text">
    <div ref="delta">
    </div>
  </section>
</template>

<script>
import Quill from 'quill';

export default {
  name: 'InputDeltaText',
  props: ['value'],
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal && !oldVal) {
        this.editor.setContents(this.value);
      }
    },
  },
  mounted() {
    this.editor = new Quill(this.$refs.delta, {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          ['link'],
          [{ list: 'bullet' }],
          ['clean'],
          ['video'],
        ],
      },
      theme: 'snow',
    });

    this.editor.on('text-change', () => {
      this.$emit('input', this.editor.getContents());
    });
  },
};
</script>

<style lang="sass">
.input-delta-text
  padding: 0.7rem 0.4rem

  .ql-toolbar
    background: white
    border-radius: 3px 3px 0 0
    border-color: #dcdfe6
  .ql-container
    background: white
    border-radius: 0 0 3px 3px
    border-color: #dcdfe6

  .ql-editor
    min-height: 150px

</style>
